import createIcon from '../../createIcon';

/**
 * @component @name BorderVertical
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyA5SDVWN0gzVjlaTTMgNUg1VjNIM1Y1Wk03IDIxSDlWMTlIN1YyMVpNNyAxM0g5VjExSDdWMTNaTTMgMTNINVYxMUgzVjEzWk0zIDIxSDVWMTlIM1YyMVpNMyAxN0g1VjE1SDNWMTdaTTcgNUg5VjNIN1Y1Wk0xOSAxN0gyMVYxNUgxOVYxN1pNMTEgMjFIMTNWM0gxMVYyMVpNMTkgMjFIMjFWMTlIMTlWMjFaTTE5IDEzSDIxVjExSDE5VjEzWk0xOSAzVjVIMjFWM0gxOVpNMTkgOUgyMVY3SDE5VjlaTTE1IDVIMTdWM0gxNVY1Wk0xNSAyMUgxN1YxOUgxNVYyMVpNMTUgMTNIMTdWMTFIMTVWMTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BorderVertical = createIcon('BorderVertical', [
  [
    'path',
    {
      d: 'M3 9H5V7H3V9ZM3 5H5V3H3V5ZM7 21H9V19H7V21ZM7 13H9V11H7V13ZM3 13H5V11H3V13ZM3 21H5V19H3V21ZM3 17H5V15H3V17ZM7 5H9V3H7V5ZM19 17H21V15H19V17ZM11 21H13V3H11V21ZM19 21H21V19H19V21ZM19 13H21V11H19V13ZM19 3V5H21V3H19ZM19 9H21V7H19V9ZM15 5H17V3H15V5ZM15 21H17V19H15V21ZM15 13H17V11H15V13Z',
      key: 'izlncd',
    },
  ],
]);

export default BorderVertical;
